import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';




function ModifMdp() {
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false); 
  const [errorReq, setErrorReq] = useState(false)
  const [success, setSuccess] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const {token} = useParams()
  const Navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;





    useEffect(() => {
      setIsLoading(true)
      const checkToken = async () => {
        try {
          await axios.post(
            `${apiUrl}/reset-MDP/verification-Token`,
            {
                token : token
            },
            {
              withCredentials: true 
            }
          );
          setIsLoading(false)


          
        } catch (error) {
            setIsLoading(false)
            if (error.response) {
            
                setError(error.response.data.message);
              } else {
                
                setError(true)
              }
        }
      };
    
      checkToken(); 
    }, [token, Navigate, apiUrl]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); 
        setErrorReq(null);
    
        if (password === '' || passwordConfirm === '' ) {
          setErrorReq("Veuillez remplir tous les champs du formulaire.");
          setIsLoading(false);
          return;
        }
        else if(password !== passwordConfirm){
            setErrorReq("Les mots de passe ne correspondent pas");
            setIsLoading(false);
            return;
        }
    
        try {
          await axios.post(`${apiUrl}/reset-mdp/modification`, {
            mdp: password,
            mdpConfirm : passwordConfirm,
            token : token
          });
    
          setSuccess(true);
          setError(null);
          setIsLoading(false);
          setPassword('')
          setPasswordConfirm('')
    
    
        } catch (error) {
          setIsLoading(false);
          setPassword('')
          setPasswordConfirm('')
          if (error.response) {
            
            setErrorReq(error.response.data.message);
          } else {
            
            setErrorReq(true)
          }
        }
      };


  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    ); 
  }


  
  if (success) {
    return (
        <Alert key="success" style={{top:'18%'}} variant="success">
            Mot de passe modifié avec succès !
        </Alert>
    ); 
  }
  


  return (
    <>
      {confirm && 
        <Modal show={confirm} onHide={() => setConfirm(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Changer votre mot de passe</Modal.Title>
          </Modal.Header>
          <Modal.Body>
                <>Voulez-vous vraiment changer votre mot de passe ? </>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary"  onClick={()=> setConfirm(false)} >
              Annuler
            </Button>
            <Button variant="primary" onClick={(e)=> {setConfirm(false); handleSubmit(e)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
              Confirmer
            </Button>
          </Modal.Footer>
        </Modal>
      
      }
      {error ? ( 
        <Alert key="danger" style={{top:'18%'}} variant="danger">
            {error}
        </Alert>
      ):(
        <div className="container_co">
            {errorReq && 
                <Alert key="danger" variant="danger">
                    {errorReq}
                </Alert>
            }
            <h1 className="title" style={{textAlign:'center'}}>Nouveau mot de passe</h1>
            <form>
            <div>
                <label htmlFor="MDP" className="label-1">
                <br />Nouveau mot de passe<br />
                <input
                    name="mdp"
                    type="password"
                    id="Motpasse"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                </label>
            </div>
            <div>
                <label htmlFor="Motpasse" className="label-1">
                <br />Confirmer le mot de passe<br />
                <input
                    name="Confirm"
                    type="password"
                    id="Confirm"
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                />
                </label>
            </div>
            <div>
                <button type='button' onClick={()=> setConfirm(true)} style={{display:'block', margin : '0 auto'}} className="conect">
                Modifier
                </button>
            </div>
            <br/>
            <br/>
            </form>
        
        </div>

      )}


      
    </>
  );
}


export default ModifMdp;
